/**
 * @ngdoc service
 * @name picklists.factory:RsvpSeatplanElement
 *
 * @description
 *
 */
angular
    .module('festzelt-os.vouchers.main')
    .factory('Voucher', [
        'locale',
        'Resource',
        RsvpSeatplanElement
    ]);

function RsvpSeatplanElement(locale, Resource) {
    const $model = Resource.make('vouchers');

    $model.locales = ['common', 'seatplans'];
    $model.schema = locale.ready($model.locales).then(function () {
        return {
            type: 'object',
            title: locale.getString('seatplans.groups.title'),
            properties: {
                id: {
                    title: locale.getString('common.id'),
                    type: 'number',
                    listview: 'hidden',
                    mergeable: false
                }
            },
            required: ['title']
        };
    });

    return $model;
}



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/factories/voucher-factory.js